<template>
  <eagle-form
    :form-key="formKey"
  ></eagle-form>
</template>

<script>
import formMixin from '@/components/form/mixins/formMixin'
import formConfig from './siteAdminGroupFormConfig'
export default {
  mixins: [formMixin],
  data: () => ({
    formKey: 'site-admin-group-form',
    meta: {},
  }),
  methods: {
    async beforeFormInit() {
      await Promise.all([
        this.loadSiteAdminRoles(),
      ])
    },
    async loadSiteAdminRoles() {
      const result = await this.$api.collection.siteAdminApi.roles()
      this.meta.roles = result.roles
    },
    validateBeforeSave() {
      // TODO
    },
    async readApi(target) {
      return await this.$api.collection.siteAdminGroupApi.read(target)
    },
    async createApi(formData) {
      return await this.$api.collection.siteAdminGroupApi.create(formData)
    },
    async updateApi(target, formData) {
      return await this.$api.collection.siteAdminGroupApi.update(target, formData)
    },
    async deleteApi(target) {
      return await this.$api.collection.siteAdminGroupApi.delete(target)
    },
    getFormConfig() {
      return formConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
